import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Renkontiĝis du malplenaj nuksoj - frap-frap-frap! – plenfrapadis, plenkrakadis, kaj disruliĝis ĉiu al sia direkto. 
      Ruliĝas ili kaj pensas:
    </p>
    
    <p class="mb-3">
      Unua nukso: - Terure, kiom da malplenaj nuksoj aperis! Kiom longe mi vivas, neniam unu plenan mi renkontis!
    </p>
    
    <p class="mb-3">
      Dua nukso: - Kiel bone ja tiuj malplenaj nuksoj sin maskas! 
      Deflanke – normala nukso; sed post la unua sono kompreneblas jam, kun kiu vi kunpuŝiĝas!
    </p>
    
    <p class="mb-3">
      Unua nukso: - Ho, trovu mi iun ajn por interkraki dece!
    </p>
    
    <p class="mb-3">
      Dua nukso: - Ho, aŭskultu mi de iu ajn decan sonon!
    </p>
    
    <p class="mb-3">
      Ruliĝas la nuksoj, kaj ĉiu pensas pri la malpleneco de la aliu. 
      Sed pri kio ja alio povas pensi malplenaj nuksoj?
    </p>
    `
  )
}

const itemName = {
  esp: 'La nuksoj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;